import { apiFetch, ApiError } from '@/services/apiFetch'
import type { AuthUser, LoginPayload, ChangePasswordPayload } from './types'

export async function getMe(): Promise<AuthUser | null> {
  const res = await apiFetch('/api/auth/me')
  if (res.status === 401) {
    return null
  }
  if (!res.ok) {
    throw new ApiError('ME_FAILED', 'Không thể tải thông tin người dùng', res.status)
  }
  const json = (await res.json()) as { user: AuthUser }
  return json.user
}

export async function login(
  payload: LoginPayload,
): Promise<{ user: AuthUser; mustChangePassword?: boolean }> {
  const res = await apiFetch('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  const json = (await res.json()) as any
  if (!res.ok || !json.success) {
    const code = json.error?.code ?? 'LOGIN_FAILED'
    const message = json.error?.message ?? json.message ?? 'Đăng nhập thất bại'
    throw new ApiError(code, message, res.status, json.error?.details)
  }
  return { user: json.user, mustChangePassword: json.mustChangePassword }
}

export async function logout(): Promise<void> {
  const res = await apiFetch('/api/auth/logout', {
    method: 'POST',
  })
  if (!res.ok && res.status !== 401) {
    const json = (await res.json().catch(() => ({}))) as any
    throw new ApiError(
      json.error?.code ?? 'LOGOUT_FAILED',
      json.error?.message ?? 'Đăng xuất thất bại',
      res.status,
    )
  }
}

export async function changePassword(payload: ChangePasswordPayload): Promise<void> {
  const res = await apiFetch('/api/auth/change-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  const json = (await res.json()) as any
  if (!res.ok || !json.success) {
    const code = json.error?.code ?? 'CHANGE_PASSWORD_FAILED'
    const message = json.error?.message ?? 'Đổi mật khẩu thất bại'
    throw new ApiError(code, message, res.status, json.error?.details)
  }
}
